module.exports = __webpack_public_path__ + "img/search@2x.0dbc2823.png";